import apiClient, { buildQueryParams } from '../utils/apiClient';
import { handleError } from '../utils/errorHandler';
import { API_ENDPOINTS } from '../constants/apiEndpoints.constants';

/**
 * Service for Vehicle Cancellation Policies API calls
 */
const vehicleCancellationPolicyService = {
  /**
   * Get all vehicle cancellation policies with pagination and filters
   */
  getAllPolicies: async (params = {}) => {
    try {
      const {
        page = 1,
        limit = 50,
        search = '',
        status = '',
        type = '',
        sortBy = 'createdAt',
        sortOrder = 'desc',
      } = params;

      const queryParams = buildQueryParams({
        page,
        limit,
        search,
        status,
        type,
        sortBy,
        sortOrder,
      });

      return await apiClient.get(`${API_ENDPOINTS.VEHICLE_CANCELLATION_POLICIES.LIST}?${queryParams}`);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleCancellationPolicyService.getAllPolicies'));
    }
  },

  /**
   * Get a single vehicle cancellation policy by ID
   */
  getPolicyById: async (id) => {
    try {
      return await apiClient.get(API_ENDPOINTS.VEHICLE_CANCELLATION_POLICIES.GET_BY_ID(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleCancellationPolicyService.getPolicyById'));
    }
  },

  /**
   * Create a new vehicle cancellation policy
   */
  createPolicy: async (policyData) => {
    try {
      return await apiClient.post(API_ENDPOINTS.VEHICLE_CANCELLATION_POLICIES.CREATE, policyData);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleCancellationPolicyService.createPolicy'));
    }
  },

  /**
   * Update a vehicle cancellation policy
   */
  updatePolicy: async (id, policyData) => {
    try {
      return await apiClient.put(API_ENDPOINTS.VEHICLE_CANCELLATION_POLICIES.UPDATE(id), policyData);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleCancellationPolicyService.updatePolicy'));
    }
  },

  /**
   * Delete a vehicle cancellation policy
   */
  deletePolicy: async (id) => {
    try {
      return await apiClient.delete(API_ENDPOINTS.VEHICLE_CANCELLATION_POLICIES.DELETE(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleCancellationPolicyService.deletePolicy'));
    }
  },

  /**
   * Delete multiple vehicle cancellation policies
   */
  deleteMultiplePolicies: async (ids) => {
    try {
      return await apiClient.delete(API_ENDPOINTS.VEHICLE_CANCELLATION_POLICIES.DELETE_MULTIPLE, { data: { ids } });
    } catch (error) {
      throw new Error(handleError(error, 'vehicleCancellationPolicyService.deleteMultiplePolicies'));
    }
  },

  /**
   * Toggle policy status
   */
  togglePolicyStatus: async (id) => {
    try {
      return await apiClient.patch(API_ENDPOINTS.VEHICLE_CANCELLATION_POLICIES.TOGGLE_STATUS(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleCancellationPolicyService.togglePolicyStatus'));
    }
  },
};

export default vehicleCancellationPolicyService;
